import { Blocker, BlockerConfig, BsModal, AjaxStdResponse, Support }
    from './TS_Controls'

/*
    PROMISES OBJECTS ARE NOT AVAILABLE IF THE TARGET IS "es5"
    IN ORDER TO MAKE THE PROMISE OBJECT AVAILABLE, IT'S NECESSARY TO 
    MODIFY THE "LIBS" ON THE TSCONFIG.JSON FILE:
    "lib": [
            "es2015.promise", "es5", "dom",
        ],

    PROMISES ARE AVAILABLE SINCE ES2015.
    https://stackoverflow.com/questions/32408306/how-to-use-es6-promises-with-typescript
*/


interface AdminConfig {
    Panel?: string;
    ModalPanel?: string;
    Endpoint?: string;
    InsertPanel?: string;
    BlockerConfig?: BlockerConfig;
}


class ClassTypeItem {
    RecordID?: number = 0;
    Name?: string = null;
    Desc?: string = null;
}



interface ClassTypeResponse extends AjaxStdResponse {
    Item: ClassTypeItem;
    Items: ClassTypeItem[];
}



export class AdminClassTypes {

    private _cfg: AdminConfig;
    private _mdl: BsModal;
    private _blk: Blocker;

    // public NewName: KnockoutObservable<string>;

    public NewItem: KnockoutObservableType<ClassTypeItem>;
    public Items: KnockoutObservableArray<KnockoutObservableType<ClassTypeItem>>;


    constructor(config: AdminConfig) {

        this._cfg = config;
        this._mdl = new BsModal({
            Panel: config.ModalPanel,
        });
        this._blk = new Blocker(config.BlockerConfig);
        this.Setup();
    }


    private _copy: ClassTypeItem;
    public ShowEdit(item: KnockoutObservableType<ClassTypeItem>,
        evt: Event): void {
        /// CRATING A COPY OF OUR OBJECT.
        /// 
        this._copy = (ko as any).mapping.toJS(item);

        /*
        OK LET'S FIND OUR EDIT PANEL NEARBY TO THE EDIT BUTTON.
        FIRST LOOK FOR THE CONTAINER PANEL, THEN FOR THE EDIT PANEL
        CONTAINED IN IT.
        */
        let $pnlEdit = $(evt.target).closest('[data-item="panel-item"]')
            .find('[data-item="panel-edit"]');

        this._mdl.Display({
            Title: "Edit Class Type",
            DomObj: $pnlEdit,
            Buttons: [
                {
                    Text: 'Update Class Type',
                    Class: 'btn btn-primary',
                    Callback: (evt) => {
                        this.Editing(item);
                    },
                },
                {
                    Text: 'Cancel',
                    Class: 'btn btn-default',
                    Callback: (evt) => this.CancelEdit(item),
                },
            ],
            OnVisibility: (viz: boolean) => {
                if (viz) {
                    $pnlEdit.removeClass("as-hidden");
                } else {
                    $pnlEdit.addClass("as-hidden");
                }
            }
        });

    }



    public Editing(currItem: KnockoutObservableType<ClassTypeItem>): void {
        console.log("Class edited: ", currItem);

        this._blk.Block();

        var i: ClassTypeItem = ko.mapping.toJS<ClassTypeItem>(currItem);

        Support.Post<ClassTypeResponse>(
            this._cfg.Endpoint + "?action=edit",
            i
            ,
        ).then((accept) => {

            this.Edited(currItem, accept.Item);
            // console.log("SAVED!", accept);

        })
            .catch((errr) => this.PostError(errr))
            .then(() => {
                /*
                 UNBLOCK THE SCREEN. 
                 THIS IS LIKE A FINALLY BLOCK
                 */
                this._blk.Unblock();
            });
    }



    private Edited(currItem: KnockoutObservableType<ClassTypeItem>,
        item: ClassTypeItem): void {
        /// MAPPING THE RESULTING OBJECT ONTO THE ORIGINAL OBJECT.
        /// 
        let iof: number = this.Items.indexOf(currItem);

        currItem = ko.mapping.fromJS(item, {});

        this.SortItems();
        
        console.log("Editing completed !", currItem, item);
    }





    private CancelEdit(item: KnockoutObservableType<ClassTypeItem>): void {

        /// RESTORE OUR BACKED UP ITEM.
        item = ko.mapping.fromJS(this._copy, {}, item);

    }



    public Delete(sender: KnockoutObservableType<ClassTypeItem>): void {


        this._mdl.Confirm(
            `Are you sure you want to Delete Class Type 
                <strong>${ sender.Name()}</strong>`,
            (result: boolean) => {
                if (result) {
                    this.Deleting(sender);
                }
            },
            "Confirm Delete of Class Type"
        );
    }



    private Deleting(sender: KnockoutObservableType<ClassTypeItem>): void {

        this._blk.Block();

        var deleteObj: ClassTypeItem = ko.mapping.toJS<ClassTypeItem>(sender);

        Support.Post<ClassTypeResponse>(
            this._cfg.Endpoint + "?action=delete",
            deleteObj
            ,
        ).then((accept) => {

            this.Deleted(sender);
            // console.log("SAVED!", accept);

        })
            .catch((errr) => this.PostError(errr))
            .then(() => {
                /*
                 UNBLOCK THE SCREEN. 
                 THIS IS LIKE A FINALLY BLOCK
                 */
                this._blk.Unblock();
            });
    }



    private Deleted(sender: KnockoutObservableType<ClassTypeItem>): void {
        let iof: number = this.Items.indexOf(sender);
        this.Items.splice(iof, 1);
    }





    private Load(): void {
        this._blk.Block();

        Support.Post<ClassTypeResponse>(
            this._cfg.Endpoint + "?action=load",
            {}
            ,
        ).then((accept) => {

            this.Loaded(accept.Items);
            // console.log("SAVED!", accept);

        })
            .catch((errr) => this.PostError(errr))
            .then(() => {
                /*
                 UNBLOCK THE SCREEN. 
                 THIS IS LIKE A FINALLY BLOCK
                 */
                this._blk.Unblock();
            });
    }



    private Loaded(items: ClassTypeItem[]): void {

        /// ENSURING AN EMPTY COLLECTION IF NULL RESULTS
        if (items == null) items = [];

        ko.mapping.fromJS(items, this.Items);

        this.SortItems();

        console.log("Loading completed, loaded %s items", items.length);
    }







    public ShowInsert(): void {

        this._mdl.Display({
            Title: 'Insert Class Type',
            DomSelector: this._cfg.InsertPanel,
            Buttons: [
                {
                    Text: "Create Class Type",
                    Class: 'btn btn-primary',
                    Callback: (evt) => this.Inserting(),
                },
                {
                    Text: "Cancel",
                    Class: 'btn btn-default',
                    Callback: (evt) => this.CancelInsert(),
                },
            ],
            OnVisibility: (viz: boolean) => {
                if (viz) {
                    $(this._cfg.InsertPanel).removeClass("as-hidden");
                } else {
                    $(this._cfg.InsertPanel).addClass("as-hidden");
                }
            }
        });
    }



    private PostError(msg: any) {
        this._mdl.Alert(msg, null, "Error :(");
    };



    private Inserting(): void {
        console.log("Class inserted: %s", this.NewItem.Name());

        this._blk.Block();

        // var insertObj: ClassTypeItem = {
        //     Name: this.NewName(),
        // };

        let insertObj: ClassTypeItem = ko.mapping.toJS(this.NewItem) as ClassTypeItem;

        Support.Post<ClassTypeResponse>(
            this._cfg.Endpoint + "?action=insert",
            insertObj
            ,
        ).then((accept) => {

            this.Inserted(accept.Item);
            // console.log("SAVED!", accept);

        })
            .catch((errr) => this.PostError(errr))
            .then(() => {
                /*
                 UNBLOCK THE SCREEN. 
                 THIS IS LIKE A FINALLY BLOCK
                 */
                this._blk.Unblock();
            });

    }



    private Inserted(newItem: ClassTypeItem) {

        // let newItem: ClassTypeItem = {
        //     Name: this.NewName(),
        //     Desc: null,
        // };

        /// CREATE A KO OBJECT FROM THE RESULTING OBJECT.
        ///
        let newObj = ko.mapping.fromJS(newItem, {});

        /// PUSH IT TO THE COLLECTION.
        ///
        this.Items.push(newObj);

        /*
        CLEAR THE INSERT FORM
        */
        this.ResetInsertForm();


        this.SortItems();
    }



    private CancelInsert(): void {
        /*
        CLEAR THE INSERT FORM
        */
        this.ResetInsertForm();
    }



    private ResetInsertForm(): void {
        ko.mapping.fromJS(new ClassTypeItem(), this.NewItem as any);
    }




    private SortItems(): void {

        /*
        SORTING OBSERVABLE ARRAY (KNOCKOUT)
        http://www.c-sharpcorner.com/UploadFile/cd7c2e/apply-sort-function-on-observable-array-using-knockoutjs/
        */

        this.Items.sort((l, r) => {
            let ln: string = l.Name().toLowerCase();
            let rn: string = r.Name().toLowerCase();


            let rval = -1;

            if (ln == rn) rval = 0;
            if (ln > rn) rval = 1;
            
            return rval;
        });
    }



    private Setup(): void {

        /// ENSURING THERE IS AN EMPTY COLLECTION TO WORK WITH INITIALLY.
        /// 
        this.Items = ko.mapping.fromJS([], {}) as any;

        this.NewItem = ko.mapping.fromJS(new ClassTypeItem());

        ko.applyBindings(this, $(this._cfg.Panel)[0]);

        this.Load();
    }

}













// WEBPACK FOOTER //
// ./js/TS_ClassType.ts